(function () {
  'use strict';
  const lifetime = 30 * 60 * 1000;
  const pairs = {
    'family-edition': 'edicion-familia',
    'couples-edition': 'edicion-parejas',
    'kids-edition': 'edicion-ninos',
    'life-story-interview-kit': 'edicion-historia-de-vida',
    'family-edition-digital-version': 'spanish-family-edition-digital-version',
    'couples-edition-digital-version': 'spanish-couples-edition-digital-version',
    'tales-life-story-new-edition-digital-version': 'tales-historia-de-vida-version-digital',
  };
  function handle(url) { return url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1]; }
  function isLegacyView(view, config) { return view === config.view || view === 'tales-family-legacy'; }
  function localizedPath(url) {
    const current = handle(url);
    const spanish = url.pathname.startsWith('/es/');
    const target = spanish ? pairs[current] : Object.keys(pairs).find(key => pairs[key] === current);
    return target ? (spanish ? '/es' : '') + '/products/' + target : url.pathname;
  }
  function destination(href, variant, config, origin) {
    const url = new URL(href, origin);
    if (url.origin !== origin) return url.href;
    const view = url.searchParams.get('view');
    if (!config.eligibleHandles.includes(handle(url))) {
      if (handle(url) && isLegacyView(view, config)) url.searchParams.delete('view');
      return url.href;
    }
    if (view && view !== config.view) return url.href;
    if (variant === 'legacy') url.searchParams.set('view', config.view);
    else if (variant === 'current') url.searchParams.delete('view');
    return url.href;
  }
  function validAssignment(record, config, now) {
    return record && record.experiment === config.experimentId && record.expires > now &&
      ['legacy', 'current'].includes(record.variant) ? record : null;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { destination, validAssignment, localizedPath };
    return;
  }
  const config = JSON.parse(document.getElementById('tales-pdp-test-config').textContent);
  const preview = Number(window.Shopify?.theme?.id) === config.previewThemeId;
  const active = config.enabled || preview;
  const key = 'tales-pdp-test:' + config.experimentId;
  let assignment = null;
  function save(variant) {
    assignment = { variant, experiment: config.experimentId, expires: Date.now() + lifetime };
    try { sessionStorage.setItem(key, JSON.stringify(assignment)); }
    catch (error) { console.warn('Tales PDP assignment storage unavailable:', error); }
  }
  if (active) {
    try { assignment = validAssignment(JSON.parse(sessionStorage.getItem(key)), config, Date.now()); }
    catch (error) { console.warn('Tales PDP assignment could not be read:', error); }
    const current = new URL(location.href);
    const force = current.searchParams.get('tales_pdp_preview');
    if (preview && ['legacy', 'current'].includes(force)) save(force);
    else if (preview && current.searchParams.get('view') === config.view) save('legacy');
    else if (assignment) save(assignment.variant);
  }
  function route(href) {
    return active && assignment ? destination(href, assignment.variant, config, location.origin) : new URL(href, location.origin).href;
  }
  // Existing locale redirects run in the head. Preserve attribution/preview
  // parameters, but never carry a variant ID to a different Shopify product.
  window.talesPdpLocaleRedirect = function (path) {
    const current = new URL(location.href);
    const target = new URL(path, location.origin);
    if (active && handle(current)) {
      const mapped = localizedPath(current);
      if (mapped !== current.pathname) target.pathname = mapped;
    }
    target.search = current.search;
    target.hash = current.hash;
    if (handle(target) !== handle(current)) target.searchParams.delete('variant');
    // Preserve existing unavailable-language destinations outside the experiment.
    // Those products must use their normal template and disabled purchase controls.
    if (handle(target) && !config.eligibleHandles.includes(handle(target)) && isLegacyView(target.searchParams.get('view'), config)) {
      target.searchParams.delete('view');
    }
    location.replace(route(target.href));
  };
  if (window.talesPdpLocaleTarget) {
    window.talesPdpLocaleRedirect(window.talesPdpLocaleTarget);
    return;
  }
  function refreshLinks() {
    if (!assignment) return;
    document.querySelectorAll('a[href]').forEach(link => {
      if (link.origin === location.origin && handle(new URL(link.href))) link.href = route(link.href);
    });
  }
  window.talesPdpTest = {
    assign(variant) {
      if (!active || !['legacy', 'current'].includes(variant)) return null;
      const url = new URL(location.href);
      // Only Visually can enroll a live visitor. Its audience handles country;
      // this additional guard excludes Spanish entry and non-PDP entry.
      if (!assignment && (url.pathname.startsWith('/es/') || !config.eligibleHandles.includes(handle(url)))) return null;
      save(variant);
      refreshLinks();
      return route(location.href);
    },
  };
  if (!active) return;
  const current = new URL(location.href);
  const localized = localizedPath(current);
  if (config.eligibleHandles.includes(handle(current)) && localized !== current.pathname) {
    current.pathname = localized;
    current.searchParams.delete('variant');
  }
  const target = route(current.href);
  if (target !== location.href) { location.replace(target); return; }
  document.addEventListener('DOMContentLoaded', refreshLinks);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && assignment && link.origin === location.origin) link.href = route(link.href);
  }, true);
})();
